export default "__VITE_ASSET__BvU43rl5__"